<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="saveMedicineCourse">
        <mdb-modal side position="right" fullHeight direction="right" :show="modal" @close="close">
          <mdb-modal-header>
              <mdb-modal-title class="h4">Verlauf anlegen</mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body class="example-card scrollbar-blue thin">
            <validation-provider
              name="Medikamentenblatt"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-select
                multiple
                outline
                ref="medikamentenblatt"
                id="medikamentenblatt"
                v-model="lagerungsartOptions"
                label="Medikamentenblatt"
                name="Medikamentenblatt"
                placeholder="Medikamentenblatt"
                @getValue="getMedicineValue"
                validation
              />
            </validation-provider>
            <validation-provider
              name="Art"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-select
                outline
                id="art"
                ref="art"
                v-model="artMedicineCourseOption"
                label="Art"
                name="Art"
                placeholder="Art"
                validation
                @getValue="getArtValue"
              />
            </validation-provider>
            <validation-provider
              name="Datum"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-date-picker
                v-model="datum"
                disabledFuture
                label="Datum"
                name="Datum"
                :option="optionDatePicker"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
                outline
                @getValue="getPickersValue"
              />
            </validation-provider>
            <validation-provider
              name="Uhrzeit"
              rules="required"
              v-slot="{ errors, valid, invalid }"
              slim
            >
              <mdb-time-picker
                id="uhrzeit"
                v-model="uhrzeit"
                label="Uhrzeit"
                name="Uhrzeit"
                :hours-format="24"
                class="mb-0"
                outline
                :done-label="optionTimePicker.done"
                :closeLabel="optionTimePicker.cancel"
                :clearLabel="optionTimePicker.clear"
                @getValue="verifyValue"
              />
              <span v-if="valid" class="valid-feedback d-block">sieht gut aus</span>
              <span v-if="invalid" class="invalid-feedback d-block">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider
                v-if="showKommentar"
                name="Kommentar"
                rules="max:500"
                v-slot="{ errors, valid, validated }"
                slim
              >
                <mdb-input
                  v-model="form.Kommentar"
                  type="textarea"
                  :rows="5"
                  label="Kommentar"
                  name="Kommentar"
                  :customValidation="validated"
                  :isValid="valid"
                  :invalidFeedback="errors[0]"
                  validFeedback="sieht gut aus"
                  outline
                />
              </validation-provider>
          </mdb-modal-body>
          <mdb-modal-footer>
              <mdb-btn color="grey lighten-1" @click.native="close">Zurück</mdb-btn>
              <mdb-btn
                color="primary"
                :disabled="loading"
                type="submit"
              >
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import utils from '@/mixins/Utils'
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbSelect,
    mdbDatePicker,
    mdbTimePicker,
    mdbIcon,
    mdbInput
  } from 'mdbvue';

  export default {
    name: 'AddMedicineCourseModal',
    mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbSelect,
      mdbDatePicker,
      mdbTimePicker,
      mdbIcon,
      mdbInput
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
      medikament: {
        type: Array,
        default: null
      }
    },

    data() {
      return {
        modal: false,
        loading: false,
        datum: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        form: {
          Key: [],
          Datum: '',
          Art: '',
          Kommentar: '',
          Inaktiv: false,
          AenderungVon: '',
          AenderungAm: ''
        },
        defaultForm: {
          Key: [],
          Datum: '',
          Art: '',
          Kommentar: '',
          Inaktiv: false,
          AenderungVon: '',
          AenderungAm: ''
        },
        lagerungsartOptions: [],
        showKommentar: false
      }
    },

    computed: {
      selectedArtData() {
        if(this.artMedicineCourseOption) {
          let response = this.artMedicineCourseOption.find(option => {
            return option.selected === true
          });
          if (response) {
            return response.value
          }
        }
        return ""
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
      medikament (v) {
        this.lagerungsartOptions = v
      }
    },

    created() {
      this.lagerungsartOptions = this.medikament
    },

    methods: {
      close () {
        this.$refs.form.reset()
        this.datum = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.$refs.medikamentenblatt.inputText = null
        this.$refs.medikamentenblatt.inputValue = null
        this.$refs.art.inputText = null
        this.$refs.art.inputValue = null
        this.lagerungsartOptions.find(option => {
          option.selected = false
        })
        this.artMedicineCourseOption.find(option => {
          option.selected = false
        })
        this.$emit('close')
      },

      save () {
        this.close()
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.datum = value
        }
      },

      verifyValue () {
        const time = document.getElementById('uhrzeit')
        if(time) {
          if(this.uhrzeit === '' || this.uhrzeit === undefined) {
            time.classList.add('is-invalid')
            time.classList.remove('is-valid')
          }else {
            time.classList.add('is-valid')
            time.classList.remove('is-invalid')
          }
        }
      },

      getArtValue (value) {
        this.showKommentar = this.artMedicineCourseOption[value-1].kommenter
      },

      getMedicineValue(value) {
        this.form.Key = value
      },

      saveMedicineCourse () {
        // time picker validation check
        this.verifyValue()

        // select validation check
        this.$refs.medikamentenblatt.validate()
        if(this.$refs.medikamentenblatt.inputValue == null || this.$refs.medikamentenblatt.inputValue == ""){
          this.loading = false
          return
        }

        this.$refs.art.validate()
        if(this.$refs.art.inputValue == null || this.$refs.art.inputValue == ""){
          this.loading = false
          return
        }

        //set select data
        this.form.Art = this.selectedArtData


        this.form.Datum = this.formatDateY(this.datum)
        var userDate= new Date(this.form.Datum + ' ' +this.uhrzeit)
        this.form.Datum = this.serverDateFormat(userDate)
        this.form.AenderungAm =  this.form.Datum
        this.form.AenderungVon = this.loginUser.username

        this.loading = true
        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          this.$http.post('MedikamentenblattVerlauf', this.form)
            .then(res => {
                if(res.data) {
                    this.$notify.success({message: 'Verlauf anlegen erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
                    this.save()
                }else {
                    this.$notify.error({message: 'Gescheitert Verlauf anlegen !!', position: 'top right', closeButton: false, timeOut: 5000})
                }
            })
            .finally(() => {
                this.loading = false
            })
          // Wait until the models are updated in the UI
          this.$nextTick(() => {
            this.$refs.form.reset()
          });
        });
      },
    }
  }
</script>
